/* THIS FILE IS AUTO-GENERATED – DO NOT EDIT */

import {forwardRef, type ForwardRefExoticComponent, type RefAttributes, type SVGProps} from 'react'

/**
 * @public
 */
export const SquareIcon: ForwardRefExoticComponent<
  Omit<SVGProps<SVGSVGElement>, 'ref'> & RefAttributes<SVGSVGElement>
> = /* @__PURE__ */ forwardRef(function SquareIcon(props, ref) {
  return (
    <svg
      data-sanity-icon="square"
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <rect
        x={5.5}
        y={5.5}
        width={14}
        height={14}
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinejoin="round"
      />
    </svg>
  )
})
